module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.organization')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('data-form', {
    attrs: {
      "model": "organizations",
      "entity": _vm.organization,
      "fields": _vm.fields,
      "before-submit": _vm.beforeSubmit,
      "after-submit": _vm.afterSubmit
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-users')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": "users",
      "columns": ['email'],
      "isSelected": _vm.isUserSelected
    },
    on: {
      "selection-change": _vm.userSelectChanged
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-96f8a1c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organization/OrganizationDetails.vue
// module id = 1022
// module chunks = 2